import React from "react";
import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <StyledFooter>
      <div className="footer-section">
        <Typography variant="h6" className="section-title">
          Navigation
        </Typography>
        <ul>
          <li>
            <Link to={"/"}>Home</Link>
          </li>
          <li>
            <Link to={"/login"}>Login</Link>
          </li>
          <li>
            <Link to={"/pricing"}>Pricing</Link>
          </li>
          <li>
            <Link to={"/about"}>About</Link>
          </li>
        </ul>
      </div>
      <div className="footer-section">
        <Typography variant="h6" className="section-title">
          Products
        </Typography>
        <ul>
          <li>
            <Link to={"/asana-in-the-inbox"}>Asana in the Inbox</Link>
          </li>
          <li>
            <Link to={"/monday-in-the-inbox"}>monday in the Inbox</Link>
          </li>
          <li>
            <Link to={"/profanity-filter"}>Profanity Filter</Link>
          </li>
          <li>
            <Link to={"/explicit-image-blocker"}>Explicit Image Blocker</Link>
          </li>
          <li>
            <Link to={"/asana-in-zendesk"}>Asana in Zendesk</Link>
          </li>
        </ul>
      </div>
      <div className="footer-section">
        <Typography variant="h6" className="section-title">
          Legal
        </Typography>
        <ul>
          <li>
            <Link to={"/terms-of-service"}>Terms of Service</Link>
          </li>
          <li>
            <Link to={"/privacy-policy"}>Privacy Policy</Link>
          </li>
        </ul>
      </div>
      <div className="footer-section">
        <Typography variant="h6" className="section-title">
          Contact
        </Typography>
        <p>
          Contact us: <a href="mailto:support@thackd.com">support@thackd.com</a>
        </p>
        <p className="copyright">© 2026 thackd.com</p>
      </div>
    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 2rem;
  margin-top: 10rem;
  background-color: #f8f9fa;
  border-top: 1px solid #e0e0e0;

  .footer-section {
    flex: 1 1 200px;
    margin: 1rem;

    .section-title {
      font-weight: bold;
      margin-bottom: 1rem;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 0.5rem;
      }

      a {
        text-decoration: none;
        color: #007bff;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .copyright {
      font-size: 0.8rem;
      margin-top: 1rem;
    }
  }
`;

export default Footer;
